<template>
	<div class="mt-3 py-5">
		<b-container>

			<div class="content mb-auto">
				<div class="container-fluid sp-form-container">

					<!--Main layout-->
					<div class="container pl-3 pr-3">


            <div class="row justify-content-center">

                <div class="col-md-2">
                </div>
                <div class="col-md-8">
                    <template v-if="initError">
                      <div class="card">
                          <div class="card-body pr-3 pl-3">
                            <p>{{ errorMsg }}</p>
                          </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="card">
                          <div class="card-header">試弾申し込み</div>
                          <div class="card-body pr-0 pl-0">

                            <template v-if="isNotName">
                              <div class="row m-3 mb-0 pb-0">
                                <div class="form-group col-sm-12 mb-0">
                                  <label for="dummy" class="control-label mb-0">お名前  <span class="required_mark">必須</span></label>
                                </div>
                              </div>
                              <div class="row m-3">
                                  <div class="form-group col-sm-6">
                                      <label class="col-sm-6 control-label">姓  <span class="required_mark">必須</span></label>
                                      <input  type="text" placeholder="山本" v-model="sendForm.last_name" class="required form-control" v-bind:class="{ error_input: sendForm.errors.last_name.length > 0 }">
                                      <div v-if="sendForm.errors.last_name.length > 0">
                                        <div class="error-text" v-for="(item, index) in sendForm.errors.last_name" :key="index">{{ item }}</div>
                                      </div>
                                  </div>
                                  <div class="form-group col-sm-6">
                                      <label class="col-sm-6 control-label">名  <span class="required_mark">必須</span></label>
                                      <input  type="text" placeholder="太郎" v-model="sendForm.first_name" class="required form-control" v-bind:class="{ error_input: sendForm.errors.first_name.length > 0 }">
                                      <div v-if="sendForm.errors.first_name.length > 0">
                                        <div class="error-text" v-for="(item, index) in sendForm.errors.first_name" :key="index">{{ item }}</div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row m-3">
                                  <div class="form-group col-sm-6">
                                      <label class="col-sm-6 control-label">セイ  <span class="required_mark">必須</span></label>
                                      <input  type="text" placeholder="" v-model="sendForm.phonetic_last_name" class="required form-control" v-bind:class="{ error_input: sendForm.errors.phonetic_last_name.length > 0 }">
                                      <div v-if="sendForm.errors.phonetic_last_name.length > 0">
                                        <div class="error-text" v-for="(item, index) in sendForm.errors.phonetic_last_name" :key="index">{{ item }}</div>
                                      </div>
                                  </div>
                                  <div class="form-group col-sm-6">
                                      <label class="col-sm-6 control-label">メイ  <span class="required_mark">必須</span></label>
                                      <input  type="text" placeholder="" v-model="sendForm.phonetic_first_name" class="required form-control" v-bind:class="{ error_input: sendForm.errors.phonetic_first_name.length > 0 }">
                                      <div v-if="sendForm.errors.phonetic_first_name.length > 0">
                                        <div class="error-text" v-for="(item, index) in sendForm.errors.phonetic_first_name" :key="index">{{ item }}</div>
                                      </div>
                                  </div>
                              </div>
                            </template>
                            <template v-if="isNotNickName">
                              <div class="row m-3 mb-0 pb-0">
                                <div class="form-group col-sm-12 mb-0">
                                  <label for="dummy" class="control-label mb-0">ハンドルネーム  <span class="required_mark">必須</span></label>
                                </div>
                              </div>
                              <div class="row m-3">
                                  <div class="form-group col-sm-12">
                                      <input  type="text" placeholder="" v-model="sendForm.nickname" class="required form-control" v-bind:class="{ error_input: sendForm.errors.nickname.length > 0 }">
                                      <div v-if="sendForm.errors.nickname.length > 0">
                                        <div class="error-text" v-for="(item, index) in sendForm.errors.nickname" :key="index">{{ item }}</div>
                                      </div>
                                  </div>
                                  <div class="col-sm-12">
                                    ※レビュー（口コミ）の投稿で使用します
                                  </div>
                              </div>
                            </template>

                            <div class="row m-3">
                              <div class="col-sm-12 form-group">
                                  <div class="">
                                      <label for="how_to_reply" class="control-label">連絡を受ける方法  <span class="required_mark">必須</span></label>
                                      <div class="">
                                        <label class="checkbox-inline p-3">
                                            <input  type="radio" v-model="sendForm.how_to_reply" value="1">
                                            メッセージ
                                        </label>
                                        <label class="checkbox-inline p-3">
                                            <input  type="radio" v-model="sendForm.how_to_reply" value="2">
                                            電話
                                        </label>
                                        <template v-if="String(sendForm.how_to_reply)=='2'">
                                          <p class="col-sm-12 tel_str">
                                            電話番号： 
                                            <input  type="tel" placeholder="" v-model="sendForm.phone" class="form-control" v-bind:class="{ error_input: sendForm.errors.phone.length > 0 }">
                                          </p>
                                          <div class="col-sm-12" v-if="sendForm.errors.phone.length > 0">
                                            <div class="error-text" v-for="(item, index) in sendForm.errors.phone" :key="index">{{ item }}</div>
                                          </div>
                                        </template>
                                      </div>
                                  </div>
                                  <div class="row pr-3 pl-3">
                                      <div class="col-sm-12 text-danger" style="font-size: 0.9rem;">
                                          ※「メッセージ」とは、自分のメールアドレスを相手に知らせることなく、サイト内でやり取りできる便利なメッセージ（チャット）機能です<br>
                                          <span class="tel_str" v-if="String(sendForm.how_to_reply)=='2'">※電話番号は間違いのないようにしてください<br></span>
                                          ※電話を選択されても、販売者の都合、または不在で連絡がつかない等により、メッセージでの返信になる場合もあります
                                      </div>
                                  </div>
                              </div>
                            </div>
        
                            <div class="row m-3">
                              <div class="form-group">
                                  <label for="reservation_date" class="col-sm-12 control-label">試弾希望日時  <!--<span class="required_mark">必須</span>-->
                                  <div><span>試弾希望日時を、第三希望までお書きください</span></div>
                                  </label>

                                  <div class="row mx-1">
                                      <div class="col-sm-12">
                                        <span class="my-3 d-block">希望1 : </span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_date_1.length > 0 }" v-model="reservation_date_1_year">
                                          <option value="">未選択</option><option v-for="(item, index) in year" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">年</span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_date_1.length > 0 }" v-model="reservation_date_1_month">
                                          <option value="">未選択</option><option v-for="(item, index) in month" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">月</span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_date_1.length > 0 }" v-model="reservation_date_1_day">
                                          <option value="">未選択</option><option v-for="(item, index) in day" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">日</span>
                                        <div v-if="sendForm.errors.reservation_date_1.length > 0">
                                          <div class="error-text" v-for="(item, index) in sendForm.errors.reservation_date_1" :key="index">{{ item }}</div>
                                        </div>
                                      </div>
                                  </div>
                                  <div class="row mx-1 mt-3">
                                      <div class="col-sm-12">
                                        <span class="mt-3">  時間帯</span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_time_from_1.length > 0 }" v-model="reservation_time_from_1_hour">
                                          <option value="">未選択</option><option v-for="(item, index) in hour" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">時</span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_time_from_1.length > 0 }" v-model="reservation_time_from_1_minute">
                                          <option value="">未選択</option><option v-for="(item, index) in minute" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">分</span>
                                        <span class="mt-3 ml-3 mr-3">  ～  </span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_time_to_1.length > 0 }" v-model="reservation_time_to_1_hour">
                                          <option value="">未選択</option><option v-for="(item, index) in hour" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">時</span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_time_to_1.length > 0 }" v-model="reservation_time_to_1_minute">
                                          <option value="">未選択</option><option v-for="(item, index) in minute" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">分</span>
                                        <div v-if="sendForm.errors.reservation_time_from_1.length > 0">
                                          <div class="error-text" v-for="(item, index) in sendForm.errors.reservation_time_from_1" :key="index">{{ item }}</div>
                                        </div>
                                        <div v-if="sendForm.errors.reservation_time_to_1.length > 0">
                                          <div class="error-text" v-for="(item, index) in sendForm.errors.reservation_time_to_1" :key="index">{{ item }}</div>
                                        </div>
                                      </div>
                                  </div><hr class="mb-0 mx-3" />

                                  <div class="row mx-1">
                                      <div class="col-sm-12">
                                        <span class="my-3 d-block">希望2 : </span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_date_2.length > 0 }" v-model="reservation_date_2_year">
                                          <option value="">未選択</option><option v-for="(item, index) in year" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">年</span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_date_2.length > 0 }" v-model="reservation_date_2_month">
                                          <option value="">未選択</option><option v-for="(item, index) in month" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">月</span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_date_2.length > 0 }" v-model="reservation_date_2_day">
                                          <option value="">未選択</option><option v-for="(item, index) in day" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">日</span>
                                        <div v-if="sendForm.errors.reservation_date_2.length > 0">
                                          <div class="error-text" v-for="(item, index) in sendForm.errors.reservation_date_2" :key="index">{{ item }}</div>
                                        </div>
                                      </div>
                                  </div>
                                  <div class="row mx-1 mt-3">
                                      <div class="col-sm-12">
                                        <span class="mt-3">  時間帯</span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_time_from_2.length > 0 }" v-model="reservation_time_from_2_hour">
                                          <option value="">未選択</option><option v-for="(item, index) in hour" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">時</span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_time_from_2.length > 0 }" v-model="reservation_time_from_2_minute">
                                          <option value="">未選択</option><option v-for="(item, index) in minute" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">分</span>
                                        <span class="mt-3 ml-3 mr-3">  ～  </span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_time_to_2.length > 0 }" v-model="reservation_time_to_2_hour">
                                          <option value="">未選択</option><option v-for="(item, index) in hour" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">時</span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_time_to_2.length > 0 }" v-model="reservation_time_to_2_minute">
                                          <option value="">未選択</option><option v-for="(item, index) in minute" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">分</span>
                                        <div v-if="sendForm.errors.reservation_time_from_2.length > 0">
                                          <div class="error-text" v-for="(item, index) in sendForm.errors.reservation_time_from_2" :key="index">{{ item }}</div>
                                        </div>
                                        <div v-if="sendForm.errors.reservation_time_to_2.length > 0">
                                          <div class="error-text" v-for="(item, index) in sendForm.errors.reservation_time_to_2" :key="index">{{ item }}</div>
                                        </div>
                                      </div>
                                  </div><hr class="mb-0 mx-3" />

                                  <div class="row mx-1">
                                      <div class="col-sm-12">
                                        <span class="my-3 d-block">希望3 : </span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_date_3.length > 0 }" v-model="reservation_date_3_year">
                                          <option value="">未選択</option><option v-for="(item, index) in year" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">年</span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_date_3.length > 0 }" v-model="reservation_date_3_month">
                                          <option value="">未選択</option><option v-for="(item, index) in month" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">月</span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_date_3.length > 0 }" v-model="reservation_date_3_day">
                                          <option value="">未選択</option><option v-for="(item, index) in day" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">日</span>
                                        <div v-if="sendForm.errors.reservation_date_3.length > 0">
                                          <div class="error-text" v-for="(item, index) in sendForm.errors.reservation_date_3" :key="index">{{ item }}</div>
                                        </div>
                                      </div>
                                  </div>
                                  <div class="row mx-1 mt-3">
                                      <div class="col-sm-12">
                                        <span class="mt-3">  時間帯</span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_time_from_3.length > 0 }" v-model="reservation_time_from_3_hour">
                                          <option value="">未選択</option><option v-for="(item, index) in hour" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">時</span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_time_from_3.length > 0 }" v-model="reservation_time_from_3_minute">
                                          <option value="">未選択</option><option v-for="(item, index) in minute" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">分</span>
                                        <span class="mt-3 ml-3 mr-3">  ～  </span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_time_to_3.length > 0 }" v-model="reservation_time_to_3_hour">
                                          <option value="">未選択</option><option v-for="(item, index) in hour" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">時</span>
                                        <select v-bind:class="{ error_input: sendForm.errors.reservation_time_to_3.length > 0 }" v-model="reservation_time_to_3_minute">
                                          <option value="">未選択</option><option v-for="(item, index) in minute" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                        </select><span class="mt-3 ml-2 mr-2">分</span>
                                        <div v-if="sendForm.errors.reservation_time_from_3.length > 0">
                                          <div class="error-text" v-for="(item, index) in sendForm.errors.reservation_time_from_3" :key="index">{{ item }}</div>
                                        </div>
                                        <div v-if="sendForm.errors.reservation_time_to_3.length > 0">
                                          <div class="error-text" v-for="(item, index) in sendForm.errors.reservation_time_to_3" :key="index">{{ item }}</div>
                                        </div>
                                      </div>
                                  </div><hr class="mb-0 mx-3" />
                              </div>
                            </div>

                            <div class="row m-3">
                              <div class="form-group col-sm-12"><!--  max_count -->
                                  <div class="col-sm-12 p-0">
                                      <label class="control-label">伝えたい内容等  <span class="required_mark">必須</span></label>
                                      <textarea  placeholder="" v-model="sendForm.comment" class="required form-control" rows="5" maxlength="1000" v-bind:class="{ error_input: sendForm.errors.comment.length > 0 }"></textarea>
                                      <div v-if="sendForm.errors.comment.length > 0">
                                        <div class="error-text" v-for="(item, index) in sendForm.errors.comment" :key="index">{{ item }}</div>
                                      </div>
                                  </div>
                              </div>
                            </div>

                            <div class="row m-3">
                              <div class="form-group col-sm-12 p-0 m-0">
                                  <div style="border: solid 2px #d7d7d7;" class="m-0 p-3">
                                      <label for="confirm_item" class="col-sm-12 control-label">□ 規約確認項目</label>
                                      <div id="confirm_item">
                                        <br>
                                        この利用規約（以下，「本規約」といいます。）は，ピアチュウ（以下，「当社」といいます。）がこのウェブサイト上で提供するサービス（以下，「本サービス」といいます。）の利用条件を定めるものです。登録ユーザーの皆さま（以下，「ユーザー」といいます。）には，本規約に従って，本サービスをご利用いただきます。
                                        <p>第1条（適用）<br>
                                          本規約は，ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。</p>
                                        <p>第2条（利用登録）<br>
                                          登録希望者が当社の定める方法によって利用登録を申請し，当社がこれを承認することによって，利用登録が完了するものとします。<br>
                                          当社は，利用登録の申請者に以下の事由があると判断した場合，利用登録の申請を承認しないことがあり，その理由については一切の開示義務を負わないものとします。<br>
                                          （1）利用登録の申請に際して虚偽の事項を届け出た場合<br>
                                          （2）本規約に違反したことがある者からの申請である場合<br>
                                          （3）その他，当社が利用登録を相当でないと判断した場合<br>
                                          第3条（ユーザーIDおよびパスワードの管理）<br>
                                          ユーザーは，自己の責任において，本サービスのユーザーIDおよびパスワードを管理するものとします。<br>
                                          ユーザーは，いかなる場合にも，ユーザーIDおよびパスワードを第三者に譲渡または貸与することはできません。当社は，ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には，そのユーザーIDを登録しているユーザー自身による利用とみなします。<br>
                                          第4条（利用料金および支払方法）<br>
                                          ユーザーは，本サービス利用の対価として，当社が別途定め，本ウェブサイトに表示する利用料金を，当社が指定する方法により支払うものとします。<br>
                                          ユーザーが利用料金の支払を遅滞した場合には，ユーザーは年１４．６％の割合による遅延損害金を支払うものとします。<br>
                                          第5条（禁止事項）<br>
                                          ユーザーは，本サービスの利用にあたり，以下の行為をしてはなりません。</p>
                                        <p>（1）法令または公序良俗に違反する行為<br>
                                          （2）犯罪行為に関連する行為<br>
                                          （3）当社のサーバーまたはネットワークの機能を破壊したり，妨害したりする行為<br>
                                          （4）当社のサービスの運営を妨害するおそれのある行為<br>
                                          （5）他のユーザーに関する個人情報等を収集または蓄積する行為<br>
                                          （6）他のユーザーに成りすます行為<br>
                                          （7）当社のサービスに関連して，反社会的勢力に対して直接または間接に利益を供与する行為<br>
                                          （8）その他，当社が不適切と判断する行為<br>
                                          第6条（本サービスの提供の停止等）<br>
                                          当社は，以下のいずれかの事由があると判断した場合，ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。<br>
                                          （1）本サービスにかかるコンピュータシステムの保守点検または更新を行う場合<br>
                                          （2）地震，落雷，火災，停電または天災などの不可抗力により，本サービスの提供が困難となった場合<br>
                                          （3）コンピュータまたは通信回線等が事故により停止した場合<br>
                                          （4）その他，当社が本サービスの提供が困難と判断した場合<br>
                                          当社は，本サービスの提供の停止または中断により，ユーザーまたは第三者が被ったいかなる不利益または損害について，理由を問わず一切の責任を負わないものとします。<br>
                                          第7条（利用制限および登録抹消）<br>
                                          当社は，以下の場合には，事前の通知なく，ユーザーに対して，本サービスの全部もしくは一部の利用を制限し，またはユーザーとしての登録を抹消することができるものとします。<br>
                                          （1）本規約のいずれかの条項に違反した場合<br>
                                          （2）登録事項に虚偽の事実があることが判明した場合<br>
                                          （3）その他，当社が本サービスの利用を適当でないと判断した場合<br>
                                          当社は，本条に基づき当社が行った行為によりユーザーに生じた損害について，一切の責任を負いません。<br>
                                          第8条（免責事項）<br>
                                          当社の債務不履行責任は，当社の故意または重過失によらない場合には免責されるものとします。<br>
                                          当社は，何らかの理由によって責任を負う場合にも，通常生じうる損害の範囲内かつ有料サービスにおいては代金額（継続的サービスの場合には1か月分相当額）の範囲内においてのみ賠償の責任を負うものとします。<br>
                                          当社は，本サービスに関して，ユーザーと他のユーザーまたは第三者との間において生じた取引，連絡または紛争等について一切責任を負いません。<br>
                                          第9条（サービス内容の変更等）<br>
                                          当社は，ユーザーに通知することなく，本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし，これによってユーザーに生じた損害について一切の責任を負いません。</p>
                                        <p>第10条（利用規約の変更）<br>
                                          当社は，必要と判断した場合には，ユーザーに通知することなくいつでも本規約を変更することができるものとします。</p>
                                        <p>第11条（通知または連絡）<br>
                                          ユーザーと当社との間の通知または連絡は，当社の定める方法によって行うものとします。</p>
                                        <p>第12条（権利義務の譲渡の禁止）<br>
                                          ユーザーは，当社の書面による事前の承諾なく，利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し，または担保に供することはできません。</p>
                                        <p>第13条（準拠法・裁判管轄）<br>
                                          本規約の解釈にあたっては，日本法を準拠法とします。<br>
                                          本サービスに関して紛争が生じた場合には，当社の本店所在地を管轄する裁判所を専属的合意管轄とします。</p>
                                        <br>
                                        <br>
                                      </div>
                                  </div>
                              </div>
                            </div>

                            <div class="row m-3">
                              <div class="form-group col-sm-12">
                                  <div class="col-sm-12 center-block text-center">
                                      <label class="checkbox-inline p-3">
                                          <input type="checkbox" v-model="isComp" class="mr-2">利用規約に同意する <!-- @change="formCheck" -->
                                          <div v-if="sendForm.errors.isComp.length > 0">
                                            <div class="error-text" v-for="(item, index) in sendForm.errors.isComp" :key="index">{{ item }}</div>
                                          </div>
                                      </label>
                                  </div>
                              </div>
                            </div>

                            <div class="row m-3">
                              <div class="form-group col-sm-12">
                                  <div class="b100 col-sm-12">
                                    <a href="javascript:void(0);" style="color: #575757;font-size: 1rem;width: 100%;color: #fefefe;background-color: #edbb4b;" class="m-0 p-2 btn" @click="sendTestBullet">申し込む</a><!-- :disabled="!isSendButton" -->
                                  </div>
                              </div>
                            </div>
                          </div>
                      </div>
                    </template>
                </div>
                <div class="col-md-2">
                </div>

            </div>


  				</div>

				</div>
			</div>

		</b-container>
	</div>
</template>

<script>

export default {
  name: 'TestBullet',
  data () {
		const month = [
      {"no":"1","name":"1"},
			{"no":"2","name":"2"},
			{"no":"3","name":"3"},
			{"no":"4","name":"4"},
			{"no":"5","name":"5"},
			{"no":"6","name":"6"},
			{"no":"7","name":"7"},
			{"no":"8","name":"8"},
			{"no":"9","name":"9"},
			{"no":"10","name":"10"},
			{"no":"11","name":"11"},
			{"no":"12","name":"12"},
		];
		const day = [
      {"no":"1","name":"1"},
			{"no":"2","name":"2"},
			{"no":"3","name":"3"},
			{"no":"4","name":"4"},
			{"no":"5","name":"5"},
			{"no":"6","name":"6"},
			{"no":"7","name":"7"},
			{"no":"8","name":"8"},
			{"no":"9","name":"9"},
			{"no":"10","name":"10"},
			{"no":"11","name":"11"},
			{"no":"12","name":"12"},
			{"no":"13","name":"13"},
			{"no":"14","name":"14"},
			{"no":"15","name":"15"},
			{"no":"16","name":"16"},
			{"no":"17","name":"17"},
			{"no":"18","name":"18"},
			{"no":"19","name":"19"},
			{"no":"20","name":"20"},
			{"no":"21","name":"21"},
			{"no":"22","name":"22"},
			{"no":"23","name":"23"},
			{"no":"24","name":"24"},
			{"no":"25","name":"25"},
			{"no":"26","name":"26"},
			{"no":"27","name":"27"},
			{"no":"28","name":"28"},
			{"no":"29","name":"29"},
			{"no":"30","name":"30"},
			{"no":"31","name":"31"},
		];
		const hour = [
      {"no":"00","name":"00"},
      {"no":"01","name":"01"},
			{"no":"02","name":"02"},
			{"no":"03","name":"03"},
			{"no":"04","name":"04"},
			{"no":"05","name":"05"},
			{"no":"06","name":"06"},
			{"no":"07","name":"07"},
			{"no":"08","name":"08"},
			{"no":"09","name":"09"},
			{"no":"10","name":"10"},
			{"no":"11","name":"11"},
			{"no":"12","name":"12"},
			{"no":"13","name":"13"},
			{"no":"14","name":"14"},
			{"no":"15","name":"15"},
			{"no":"16","name":"16"},
			{"no":"17","name":"17"},
			{"no":"18","name":"18"},
			{"no":"19","name":"19"},
			{"no":"20","name":"20"},
			{"no":"21","name":"21"},
			{"no":"22","name":"22"},
			{"no":"23","name":"23"},
		];
		const minute = [
      {"no":"00","name":"00"},
      {"no":"01","name":"01"},
			{"no":"02","name":"02"},
			{"no":"03","name":"03"},
			{"no":"04","name":"04"},
			{"no":"05","name":"05"},
			{"no":"06","name":"06"},
			{"no":"07","name":"07"},
			{"no":"08","name":"08"},
			{"no":"09","name":"09"},
			{"no":"10","name":"10"},
			{"no":"11","name":"11"},
			{"no":"12","name":"12"},
			{"no":"13","name":"13"},
			{"no":"14","name":"14"},
			{"no":"15","name":"15"},
			{"no":"16","name":"16"},
			{"no":"17","name":"17"},
			{"no":"18","name":"18"},
			{"no":"19","name":"19"},
			{"no":"20","name":"20"},
			{"no":"21","name":"21"},
			{"no":"22","name":"22"},
			{"no":"23","name":"23"},
			{"no":"24","name":"24"},
			{"no":"25","name":"25"},
			{"no":"26","name":"26"},
			{"no":"27","name":"27"},
			{"no":"28","name":"28"},
			{"no":"29","name":"29"},
			{"no":"30","name":"30"},
			{"no":"31","name":"31"},
			{"no":"32","name":"32"},
			{"no":"33","name":"33"},
			{"no":"34","name":"34"},
			{"no":"35","name":"35"},
			{"no":"36","name":"36"},
			{"no":"37","name":"37"},
			{"no":"38","name":"38"},
			{"no":"39","name":"39"},
			{"no":"40","name":"40"},
			{"no":"41","name":"41"},
			{"no":"42","name":"42"},
			{"no":"43","name":"43"},
			{"no":"44","name":"44"},
			{"no":"45","name":"45"},
			{"no":"46","name":"46"},
			{"no":"47","name":"47"},
			{"no":"48","name":"48"},
			{"no":"49","name":"49"},
			{"no":"50","name":"50"},
			{"no":"51","name":"51"},
			{"no":"52","name":"52"},
			{"no":"53","name":"53"},
			{"no":"54","name":"54"},
			{"no":"55","name":"55"},
			{"no":"56","name":"56"},
			{"no":"57","name":"57"},
			{"no":"58","name":"58"},
			{"no":"59","name":"59"},
			{"no":"60","name":"60"},
		];

		return {
      year: [],
      month,
      day,
      hour,
      minute,

      // 様々なエラー
      errorMsg: "",
      initError: false,

      isNotName: false,
      isNotNickName: false,

      user: null,

      reservation_date_1_year: "",
      reservation_date_1_month: "",
      reservation_date_1_day: "",
      reservation_time_from_1_hour: "",
      reservation_time_from_1_minute: "",
      reservation_time_to_1_hour: "",
      reservation_time_to_1_minute: "",

      reservation_date_2_year: "",
      reservation_date_2_month: "",
      reservation_date_2_day: "",
      reservation_time_from_2_hour: "",
      reservation_time_from_2_minute: "",
      reservation_time_to_2_hour: "",
      reservation_time_to_2_minute: "",

      reservation_date_3_year: "",
      reservation_date_3_month: "",
      reservation_date_3_day: "",
      reservation_time_from_3_hour: "",
      reservation_time_from_3_minute: "",
      reservation_time_to_3_hour: "",
      reservation_time_to_3_minute: "",

      sendForm: {
				errors: {
          last_name: [],
          first_name: [],
          phonetic_last_name: [],
          phonetic_first_name: [],
          nickname: [],
          phone: [],
          how_to_reply: [],
          reservation_date_1: [],
          reservation_time_from_1: [],
          reservation_time_to_1: [],
          reservation_date_2: [],
          reservation_time_from_2: [],
          reservation_time_to_2: [],
          reservation_date_3: [],
          reservation_time_from_3: [],
          reservation_time_to_3: [],
          comment: [],
          isComp: [],
        },
        products_id: null,
        last_name: null,
        first_name: null,
        phonetic_last_name: null,
        phonetic_first_name: null,
        nickname: null,
        phone: null,
        how_to_reply: 1, // 1: メッセージ 2:電話
        reservation_date_1: null,
        reservation_time_from_1: null,
        reservation_time_to_1: null,
        reservation_date_2: null,
        reservation_time_from_2: null,
        reservation_time_to_2: null,
        reservation_date_3: null,
        reservation_time_from_3: null,
        reservation_time_to_3: null,
        comment: null,
      },
      isComp: false, // 同意
      isSendButton: false,
			isError: false,

    }
  },
  methods: {
    async current_user() {
      this.$store.dispatch('user/current_user')
      .then(res => {
        this.user = res.data.users;
        if (String(this.user['user_type'])!="1") {
          this.initError = true;
          this.errorMsg = "一般ユーザのみ申し込み可能です";
        } else {
          this.checkTestBullet();
        }
        this.sendForm.last_name = this.user['last_name'];
        this.sendForm.first_name = this.user['first_name'];
        this.sendForm.phonetic_last_name = this.user['phonetic_last_name'];
        this.sendForm.phonetic_first_name = this.user['phonetic_first_name'];
        this.sendForm.nickname = this.user['nickname'];
        this.sendForm.phone = this.user['phone'];
        if ( this.sendForm.last_name==null || this.sendForm.last_name=='' || this.sendForm.first_name==null || this.sendForm.first_name=='' || this.sendForm.phonetic_last_name==null || this.sendForm.phonetic_last_name=='' || this.sendForm.phonetic_first_name==null || this.sendForm.phonetic_first_name=='' ) {
          this.isNotName = true;
        }
        if ( this.sendForm.nickname==null || this.sendForm.nickname=='' ) {
          this.isNotNickName = true;
        }
        console.log(this.user);
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error);
        // if ('error' in error.response.data) {
        //   alert(error.response.data['error']);
        //   window.scrollTo({
        //     top: 0,
        //   });
        // }
      });
    },
    async checkTestBullet() {
      this.$store.dispatch('order/check_test_bullet', {
        products_id: this.$route.params.products_id,
      }).then(res => {
        let order = res.data.orders;
        console.log(order);
        if ( order['error'] ) {
          this.initError = true;
          this.errorMsg = order['msg'];
        }
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
    },
    async sendTestBulletExec() {
      this.$store.dispatch('order/post_test_bullet', {
        sendForm: this.sendForm,
      }).then(res => {
        // let order = res.data.orders;
        // console.log(order);
        alert('試弾申し込みが完了しました');
        this.$router.push({path: '/product/'+String(this.$route.params.products_id)});
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
    },
    sendTestBullet() {
      this.isError = false;
      this.sendForm.errors.last_name = [];
      this.sendForm.errors.first_name = [];
      this.sendForm.errors.phonetic_last_name = [];
      this.sendForm.errors.phonetic_first_name = [];
      this.sendForm.errors.nickname = [];
      this.sendForm.errors.phone = [];
      this.sendForm.errors.how_to_reply = [];
      this.sendForm.errors.reservation_date_1 = [];
      this.sendForm.errors.reservation_time_from_1 = [];
      this.sendForm.errors.reservation_time_to_1 = [];
      this.sendForm.errors.reservation_date_2 = [];
      this.sendForm.errors.reservation_time_from_2 = [];
      this.sendForm.errors.reservation_time_to_2 = [];
      this.sendForm.errors.reservation_date_3 = [];
      this.sendForm.errors.reservation_time_from_3 = [];
      this.sendForm.errors.reservation_time_to_3 = [];
      this.sendForm.errors.comment = [];
      this.sendForm.errors.isComp = [];
      if (!this.sendForm.last_name) {
        this.sendForm.errors.last_name.push('姓が入力されていません');
        this.isError = true;
      }
      if (!this.sendForm.first_name) {
        this.sendForm.errors.first_name.push('名が入力されていません');
        this.isError = true;
      }
      if (!this.sendForm.phonetic_last_name) {
        this.sendForm.errors.phonetic_last_name.push('セイが入力されていません');
        this.isError = true;
      }
      if (!this.sendForm.phonetic_first_name) {
        this.sendForm.errors.phonetic_first_name.push('メイが入力されていません');
        this.isError = true;
      }
      if (!this.sendForm.nickname) {
        this.sendForm.errors.nickname.push('ハンドルネームが入力されていません');
        this.isError = true;
      }
      if ( String(this.sendForm.how_to_reply) == '2' ) {
        if (this.sendForm.phone) {
          let check_num = String(this.sendForm.phone).replace(/[^0-9]/g, '');
          if (check_num == '') {
            this.sendForm.errors.phone.push('電話番号が正しく入力されていません');
            this.isError = true;
          }
        } else {
          this.sendForm.errors.phone.push('電話番号が入力されていません');
          this.isError = true;
        }
      }
      if (this.reservation_date_1_year==""||this.reservation_date_1_month==""||this.reservation_date_1_day=="") {
        this.sendForm.errors.reservation_date_1.push('希望日１が選択されていません');
        this.isError = true;
      } else {
        this.sendForm.reservation_date_1 = this.reservation_date_1_year + "/" + this.reservation_date_1_month + "/" + this.reservation_date_1_day
      }
      if (this.reservation_time_from_1_hour==""||this.reservation_time_from_1_minute=="") {
        this.sendForm.errors.reservation_time_from_1.push('希望時間１(FROM)が選択されていません');
        this.isError = true;
      } else {
        this.sendForm.reservation_time_from_1 = this.reservation_time_from_1_hour + ":" + this.reservation_time_from_1_minute
      }
      if (this.reservation_time_to_1_hour==""||this.reservation_time_to_1_minute=="") {
        this.sendForm.errors.reservation_time_to_1.push('希望時間１(TO)が選択されていません');
        this.isError = true;
      } else {
        this.sendForm.reservation_time_to_1 = this.reservation_time_to_1_hour + ":" + this.reservation_time_to_1_minute
      }
      if (this.reservation_date_2_year==""||this.reservation_date_2_month==""||this.reservation_date_2_day=="") {
        this.sendForm.errors.reservation_date_2.push('希望日２が選択されていません');
        this.isError = true;
      } else {
        this.sendForm.reservation_date_2 = this.reservation_date_2_year + "/" + this.reservation_date_2_month + "/" + this.reservation_date_2_day
      }
      if (this.reservation_time_from_2_hour==""||this.reservation_time_from_2_minute=="") {
        this.sendForm.errors.reservation_time_from_2.push('希望時間２(FROM)が選択されていません');
        this.isError = true;
      } else {
        this.sendForm.reservation_time_from_2 = this.reservation_time_from_2_hour + ":" + this.reservation_time_from_2_minute
      }
      if (this.reservation_time_to_2_hour==""||this.reservation_time_to_2_minute=="") {
        this.sendForm.errors.reservation_time_to_2.push('希望時間２(TO)が選択されていません');
        this.isError = true;
      } else {
        this.sendForm.reservation_time_to_2 = this.reservation_time_to_2_hour + ":" + this.reservation_time_to_2_minute
      }
      if (this.reservation_date_3_year==""||this.reservation_date_3_month==""||this.reservation_date_3_day=="") {
        this.sendForm.errors.reservation_date_3.push('希望日３が選択されていません');
        this.isError = true;
      } else {
        this.sendForm.reservation_date_3 = this.reservation_date_3_year + "/" + this.reservation_date_3_month + "/" + this.reservation_date_3_day
      }
      if (this.reservation_time_from_3_hour==""||this.reservation_time_from_3_minute=="") {
        this.sendForm.errors.reservation_time_from_3.push('希望時間３(FROM)が選択されていません');
        this.isError = true;
      } else {
        this.sendForm.reservation_time_from_3 = this.reservation_time_from_3_hour + ":" + this.reservation_time_from_3_minute
      }
      if (this.reservation_time_to_3_hour==""||this.reservation_time_to_3_minute=="") {
        this.sendForm.errors.reservation_time_to_3.push('希望時間３(TO)が選択されていません');
        this.isError = true;
      } else {
        this.sendForm.reservation_time_to_3 = this.reservation_time_to_3_hour + ":" + this.reservation_time_to_3_minute
      }
      if (!this.sendForm.comment) {
        this.sendForm.errors.comment.push('伝えたい内容等が入力されていません');
        this.isError = true;
      }
      if (!this.isComp) {
        this.sendForm.errors.isComp.push('利用規約の同意がチェックされていません');
        this.isError = true;
      }
      if (this.isError) {
        window.scrollTo({
          top: 0,
        });
      } else {
        this.sendTestBulletExec();
        return false;
      }
      return false;
    },
    // formCheck() {
    //   this.isSendButton = true;
    //   return false;
    // },
  },
  computed: {
  },
  created() {
    this.current_user();
    let now = new Date();
    this.year = [
			{"no":String(now.getFullYear()),"name":String(now.getFullYear())},
			{"no":String(now.getFullYear()+1),"name":String(now.getFullYear()+1)},
    ];
    this.sendForm.products_id = this.$route.params.products_id;
  },
  mounted() {
  },
  destroyed() {
  }

}
</script>

<style scoped>

/* PC */
@media screen and (max-width: 764px) {
  /* スマホ */
}

</style>



// WEBPACK FOOTER //
// src/components/TestBullet.vue